import React, { ReactElement } from 'react'

import { CustomModal } from '../CustomModal'
import './index.less'
import { SMALL_MODAL_WIDTH } from '../../../constants'

interface ModalConfirmActionProps {
  title: string
  description?: string | ReactElement
  content?: ReactElement
  yesBtnTitle: string
  noBtnTitle: string
  onYesClick: () => void
  onNoClick: () => void
  isVisible: boolean
  mode?: 'danger' | undefined
}

export const ModalConfirmAction = ({ title, description, content, yesBtnTitle, noBtnTitle, onYesClick, onNoClick, isVisible, mode }: ModalConfirmActionProps) => {
  return (
    <CustomModal
      mode={mode}
      isVisible={isVisible}
      handleClose={onNoClick}
      secondaryBtnTitle={noBtnTitle}
      handleClickPrimaryBtn={onYesClick}
      primaryBtnTitle={yesBtnTitle}
      title={title}
      width={SMALL_MODAL_WIDTH}
    >
      <div className="modalConfirmAction">
        {description ?? <p>{description}</p>}
        {content ?? content}
      </div>
    </CustomModal>
  )
}
